export default () => ({
  goToAdmin() {
    const token = localStorage.getItem("jwt_token");

    if (token) {
      // Se tem token, vai direto pro Dashboard
      window.location.href = "/admin/dashboard";
    } else {
      // Se não tem, vai pra tela de Login
      window.location.href = "/admin/login";
    }
  },
});
